import {
  Button,
  Checkbox,
  FormControlLabel,
  Paper,
  Slide,
  Table,
  TableBody,
  IconButton,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Toolbar,
  Typography,
  LinearProgress,
} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import DeleteIcon from '@material-ui/icons/DeleteSweepOutlined';
import SaveIcon from '@material-ui/icons/Save';
import Search from '@material-ui/icons/Search';
import { format, parse } from 'date-fns';
import React from 'react';
import NumberFormat from 'react-number-format';
import ElementoApi from '../../api/ElementoApi';
import GuiaApi from '../../api/GuiaApi';
import { withAuditoria } from '../../contexts/AuditoriaContext';
import { withLoading } from '../../contexts/LoadingContext';
import { withSnackbar } from '../../contexts/SnackbarContext';
import FormDialogTrocarItem from '../arquivosXML/FormDialogTrocarItem';
import AlertDialogSlide from './AlertDialogSlide';
import AlertDialog from './AlertDialog';
import ButtonAlertas from './ButtonAlertas';
import ButtonEquipe from './ButtonEquipe';
import ButtonGlosas from './ButtonGlosas';
import ButtonMotivoRecurso from './ButtonMotivoRecurso';
import DrawerGuiasDuplicidade from './DrawerGuiasDuplicidade';
import AlertDialogSlideMotivoRecurso from './AlertDialogSlideMotivoRecurso';
import LinearProgressBlockScreen from './LinearProgressBlockScreen';

const styles = theme => ({
  root: {
    display: 'block',
    padding: theme.spacing(1),
    margin: theme.spacing(0.25),
    marginTop: theme.spacing(1),
    // minWidth: '48vw',
    // maxWidth: '48vw',

  },
  tituloElementoContainerRec: {
    display: 'block',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },  
  tituloElementoContainer: {
    display: 'block',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginBottom: theme.spacing(1),
  },
  tituloElemento: {
    fontWeight: 'bold',
    color: '#414141',
  },
  textField: {
    minWidth: theme.spacing(10),
    maxWidth: theme.spacing(10),
  },
  inputResize: {
    fontSize: '14px',
    padding: '4px 0 2px 0',
  },
  tableRow: {
    display: 'flex',
    height: theme.spacing(4),
  },
  tableBody: {
    display: 'block',
  },
  tableHeadCell: {
    fontSize: '12px',
    color: '#777',
    fontWeight: 'bold',
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(10),
    maxWidth: theme.spacing(12),
    minHeight: theme.spacing(2),
    maxHeight: theme.spacing(2),
  },
  tableHeadCellBranco: {
    fontSize: '12px',
    color: '#777',
    fontWeight: 'bold',
    justifyContent: 'flex-start',
    textAlign: 'left',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(16),
    maxWidth: theme.spacing(16),
    minHeight: theme.spacing(2),
    maxHeight: theme.spacing(2),
  },  
  /*Coluna Total Glosado*/
  tableHeadCellGlosado: {
    fontSize: '12px',
    color: '#777',
    fontWeight: 'bold',
    justifyContent: 'center',
    textAlign: 'left',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minHeight: theme.spacing(2),
    maxHeight: theme.spacing(2),
    width: theme.spacing(12),
  },
  tableCellDetalheGlosado: {
    color: 'red',
    justifyContent: 'left',
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    margin: theme.spacing(0.25),
    width: theme.spacing(12),
    display: 'inline-flex',
    fontSize: 13,
  },
  tableCellDetalheSemGlosa: {
    justifyContent: 'left',
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    margin: theme.spacing(0.25),
    width: theme.spacing(12),
    display: 'inline-flex',
    fontSize: 13,
  },
  tableHeadCellMais: {
    fontSize: '12px',
    color: '#777',
    fontWeight: 'bold',
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(20),
    minHeight: theme.spacing(2),
    maxHeight: theme.spacing(2),
  },
  tableRowCell: {
    fontSize: '12px',
    color: '#777',
    fontWeight: 'bold',
    justifyContent: 'flex-start',
    textAlign: 'left',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(16),
    maxWidth: theme.spacing(16),
  },
  tableCell: {
    fontSize: '14px',
    justifyContent: 'left',
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(10),
    maxWidth: theme.spacing(12),
  },
  tableCellGlosa: {
    fontSize: '14px',
    color: 'red',
    justifyContent: 'left',
    paddingTop: theme.spacing(0.25),
    paddingBottom: theme.spacing(0.25),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(0.5),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(10),
    maxWidth: theme.spacing(12),
  },
  tableCellMaisGlosa: {
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(10),
  },
  tableCellMais: {
    justifyContent: 'center',
    textAlign: 'center',
    padding: theme.spacing(0.25),
    margin: theme.spacing(0.25),
    minWidth: theme.spacing(20),
  },
  tableCellMaisToolbar: {
    justifyContent: 'flex-start',
    alignItems: 'flex-end',
    minHeight: theme.spacing(3),
    maxHeight: theme.spacing(3),
  },

  editableClick: {
    fontSize: '0.7em',
    fontStyle: 'italic',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
  buttonOperation: {
    fontSize: 'small',
    margin: theme.spacing(0.25),
    marginLeft: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    padding: theme.spacing(0.25),
    minWidth: theme.spacing(3),
    maxWidth: theme.spacing(3),
    minHeight: theme.spacing(3),
    maxHeight: theme.spacing(3),
    '&:hover': {
      border: `0px solid ${theme.palette.primary.main}`,
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.text.hint
    },
  },
  tableCellBold: {
    fontSize: '12px',
    color: '#777',
    fontWeight: 'bold',
  },
  secondaryHeading: {
    color: theme.palette.text.secondary,
    fontSize: '0.8em',
    fontStyle: 'italic',
  },
  naoSelecionado: {
    backgroundColor: 'rgb(222, 220, 220)',
    border: '1px solid rgb(148, 146, 146)',
    '&:hover': {
      border: '1px solid black',
    },
  },
  typographyAvaliadoEditable: {
    fontSize: '14px',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    '&:hover': {
      textDecoration: 'underline',
    },
    fontWeight: 'bold',
    justifyContent: 'center',
    marginTop: theme.spacing(0.5),
    marginLeft: theme.spacing(4),
  },
  buttonAnexos: {
    fontSize: 'small',
    marginBottom: theme.spacing(1),
    margin: theme.spacing(0.25),
    marginLeft: theme.spacing(10),
    marginRight: theme.spacing(0.5),
    padding: theme.spacing(0.25),
    minHeight: theme.spacing(3),
    maxHeight: theme.spacing(3),
    '&:hover': {
      border: `0px solid ${theme.palette.primary.main}`,
      borderRadius: theme.spacing(1),
      backgroundColor: theme.palette.text.hint
    },
  },
  divBox: {
    display: '-webkit-box'
  },
  typographyEnabled: {
    color: '#3f51b5',
  },
  checkNegarEmLote: {
    marginLeft: theme.spacing(-1.5),
    marginRight: theme.spacing(-0.5),
  },
  typographyDisabled: {
    typographyBadge: {
      marginLeft: theme.spacing(1) * -1,
      marginRight: theme.spacing(1) * -1,
      color: '#3f51b5',
    },
    badgeDisabled: {
      top: '0%',
      right: -5,
      width: theme.spacing(2),
      height: theme.spacing(2),
      color: 'rgba(0, 0, 0, 0.26)',
    }
  },
  buttonAcoes: {
  }, 
  invisible: {
    display: 'none',
  },  
});

const SEQ_PRESTADOR_CNU = 28009;

class ElementoRecurso extends React.Component {
  guiaApi = new GuiaApi();
  elementoApi = new ElementoApi();

  constructor(props) {
    super(props);
    this.state = {
      elementoSelected: { ...props.elemento, dtaRealizacao: parse(props.elemento.dtaRealizacao) },      
      elementoSelectedIdx: props.idx,
      elementoEmEdicao: {},
      situacaoElemento: this.getSituacao(props.elemento),
      openDialogMotivoRecurso: false,
      guiasDuplicidades: [],
      openDrawerGuiasDuplicidade: false,
      openDialogAnexos: false,
      openDialogGlosaEmLote: false,
      dialogTitleGlosaEmLote: 'Glosa de elementos em lote',
      dialogMessageGlosaEmLote: '',
      indReplicarGlosas: false,
      isSelecionado: this.props.isSelecionado,
      openDialogTrocarItem: false,
      tituloFormDialog: '',
      fetching: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.elemento.codItem !== this.props.elemento.codItem ||
      prevProps.elemento.qtdAutorizada !== this.props.elemento.qtdAutorizada ||
      prevProps.elemento.valPctReducaoAcrescimoAutorizado !== this.props.elemento.valPctReducaoAcrescimoAutorizado ||
      prevProps.elemento.valTotalAutorizado !== this.props.elemento.valTotalAutorizado ||
      prevProps.elemento.valUnitarioAutorizado !== this.props.elemento.valUnitarioAutorizado ||
      prevProps.elemento.glosas.length !== this.props.elemento.glosas.length) {
      this.updateElementoSelected();
    }
  }

  updateElementoSelected() {
    this.props.elemento.dtaRealizacao = parse(this.props.elemento.dtaRealizacao);
    this.setState({ elementoSelected: this.props.elemento });
  }

  styleSituacaoElemento = (situacao) => {
    const { classes } = this.props;

    let classe = classes.default;
    if (situacao === 'nao_selecionado') {
      classe = classes.naoSelecionado;
    }
    return classe;
  }

  getSituacao = (elemento) => {

    let situacao = '';
    if(!this.props.isSelecionado){
      situacao = 'nao_selecionado'
    }
    return situacao;
  }

  addMotivoRecurso = () => {
    this.setState({ openDialogMotivoRecurso: true });
  }

  handleCloseDialogMotivoRecurso = () => {
    this.setState({ openDialogMotivoRecurso: false });
  }

  handleConfirmDialogMotivoRecurso = async (desMotivoRecurso) => {
    let newElemento = { ...this.state.elementoSelected };

    newElemento.txtMotivoRecurso = desMotivoRecurso;
    this.setState({ elementoSelected: newElemento });

    this.handleCloseDialogMotivoRecurso();
  }

  apagarRecurso = async (elementoSelected) => {
      this.props.showLoading('Salvando...');
      let newSelected = {...elementoSelected};

      if (elementoSelected.indPodeTrocarItem === 'N') {
        newSelected.qtdSolicitada = elementoSelected.elementoOriginalDTO.qtdAutorizada;
        newSelected.valUnitarioSolicitado = elementoSelected.elementoOriginalDTO.valUnitarioAutorizado;
        newSelected.valPctReducaoAcrescimoSolicitado = elementoSelected.elementoOriginalDTO.valPctReducaoAcrescimoAutorizado;
        newSelected.valTotalSolicitado = newSelected.qtdSolicitada * newSelected.valUnitarioSolicitado * newSelected.valPctReducaoAcrescimoSolicitado;
        newSelected.indDesistiuRecorrer = 'S';
        newSelected.txtMotivoRecurso = '-';
      } else {
        newSelected.qtdSolicitada = elementoSelected.elementoOriginalDTO.qtdSolicitada;
        newSelected.valUnitarioSolicitado = elementoSelected.elementoOriginalDTO.valUnitarioSolicitado;
        newSelected.valPctReducaoAcrescimoSolicitado = elementoSelected.elementoOriginalDTO.valPctReducaoAcrescimoSolicitado;
        newSelected.valTotalSolicitado = newSelected.qtdSolicitada * newSelected.valUnitarioSolicitado * newSelected.valPctReducaoAcrescimoSolicitado;
        newSelected.indDesistiuRecorrer = 'S';
        newSelected.txtMotivoRecurso = '-';  
        newSelected.codItemTabela = elementoSelected.elementoOriginalDTO.codItemTabela;
      }
      elementoSelected.txtMotivoRecurso = null;
      let result = await this.elementoApi.salvarAuditoriaElementoRecurso(this.props.loteSelecionado.codLoteGuia, newSelected);
      this.marcarElemento(elementoSelected);
      this.props.hideLoading();
  
      if (result === undefined || result.data === undefined) {
        this.props.showSnackbar('Não foi possível realizar a operação.', 'error', 4000, '', null, 'bottom');
        return;
      }
      if (result !== undefined && result.data.codigoRetorno === 1) {
        this.props.showLoading('Atualizando informações...');
        await this.props.onOperacaoRealizada();
        this.props.hideLoading();
        this.props.showSnackbar(result.data.msgRetornoResumida, 'success', 4000, '', null, 'bottom');
      } else {
        const { mensagens } = result.data;
        this.props.showSnackbar(mensagens, 'error', 4000, '', null, 'bottom');
      }    
  }
  salvarRecurso = async (elementoSelected) => {

    if (elementoSelected.txtMotivoRecurso === '-' || elementoSelected.txtMotivoRecurso === '' || elementoSelected.txtMotivoRecurso === null) {
      this.props.showSnackbar('Para salvar um item com recurso adicione um motivo de recurso', 'warning', 4000, '', null, 'bottom');
      return;
    }

    if (elementoSelected.valTotalSolicitado > elementoSelected.valLimiteRecurso) {
      this.props.showSnackbar('O valor limite para recorrer deste item foi ultrapassado: R$' + elementoSelected.valLimiteRecurso, 'warning', 4000, '', null, 'bottom');
      return;
    }

    this.props.showLoading('Salvando...');

    elementoSelected.indDesistiuRecorrer = 'N';
    elementoSelected.dtaRealizacao = parse(elementoSelected.dtaRealizacao);    
    let result = await this.elementoApi.salvarAuditoriaElementoRecurso(this.props.loteSelecionado.codLoteGuia, elementoSelected);

    this.props.hideLoading();

    if (result === undefined || result.data === undefined) {
      this.props.showSnackbar('Não foi possível realizar a operação.', 'error', 4000, '', null, 'bottom');
      return;
    }
    if (result !== undefined && result.data.codigoRetorno === 1) {
      this.props.onOperacaoRealizada();
      this.props.showSnackbar(result.data.msgRetornoResumida, 'success', 4000, '', null, 'bottom');
    } else {
      const { mensagens } = result.data;
      this.props.showSnackbar(mensagens, 'error', 4000, '', null, 'bottom');
    }
  }

  handleChangeValueQtde = (floatValue) => {
    const valTotalSolicitado =
      floatValue *
      this.state.elementoSelected.valUnitarioSolicitado *
      this.state.elementoSelected.valPctReducaoAcrescimoSolicitado;

    const newSelected = {
      ...this.state.elementoSelected,
      qtdSolicitada: floatValue,
      valTotalSolicitado: Number.isNaN(valTotalSolicitado) ? null
        : Number(this._roundUp(valTotalSolicitado, this.state.elementoSelected.codTipoItem === 1 && this.state.elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU ? 2 : 3).toFixed(this.state.elementoSelected.codTipoItem === 1 && this.state.elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU ? 2 : 3))
    };
    
    newSelected.valTotalSolicitado = this._roundUp(newSelected.valTotalSolicitado, 3);
    this.setState({ elementoSelected: newSelected });
  }

  handleChangeValueUnitario = (floatValue) => {

    const valTotalSolicitado =
      this.state.elementoSelected.qtdSolicitada *
      floatValue *
      this.state.elementoSelected.valPctReducaoAcrescimoSolicitado;

    const newSelected = {
      ...this.state.elementoSelected,
      valUnitarioSolicitado: floatValue,
      valTotalSolicitado: Number.isNaN(valTotalSolicitado) ? null
        : Number(this._roundUp(valTotalSolicitado, this.state.elementoSelected.codTipoItem === 1 && this.state.elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU ? 2 : 3).toFixed(this.state.elementoSelected.codTipoItem === 1 && this.state.elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU ? 2 : 3))
    };

    newSelected.valTotalSolicitado = this._roundUp(newSelected.valTotalSolicitado, 3);
    this.setState({ elementoSelected: newSelected });
  }

  handleChangeValuePct = (floatValue) => {
    let valTotalSolicitado =
      this.state.elementoSelected.qtdSolicitada *
      this.state.elementoSelected.valUnitarioSolicitado *
      floatValue;

    if (this.state.elementoSelected.valUnitarioSolicitado === null || this.state.elementoSelected.qtdSolicitada === null) {
      valTotalSolicitado = NaN;
      floatValue = null;
    }
    const newSelected = {
      ...this.state.elementoSelected,
      valPctReducaoAcrescimoSolicitado: floatValue === undefined ? 0 : floatValue,
      valTotalSolicitado: Number.isNaN(valTotalSolicitado) ? null
        : Number(this._roundUp(valTotalSolicitado, this.state.elementoSelected.codTipoItem === 1 && this.state.elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU ? 2 : 3).toFixed(this.state.elementoSelected.codTipoItem === 1 && this.state.elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU ? 2 : 3))
    };

    newSelected.valTotalSolicitado = this._roundUp(newSelected.valTotalSolicitado, 3);
    this.setState({ elementoSelected: newSelected, });
  }

  handleClickOnElemento = async (idx, elemento) => {
    // esse elemento veio via props
    if (idx !== this.state.elementoSelectedIdx) {
      elemento.dtaRealizacao = parse(elemento.dtaRealizacao);
      this.setState({
        elementoSelectedIdx: idx,
        elementoSelected: elemento,
        elementoEmEdicao: elemento,
      });
    }
  }

  handleFocusOnInput = (event) => {
    event.target.select();
  }
 

  handleViewDuplicidades = async (elemento) => {
    this.props.showLoading('Carregando..');
    const guiasDuplicidades = await this.guiaApi.consultarGuiasDuplicadas(this.props.loteSelecionado.codLoteGuia, elemento.codGuia, elemento);
    this.props.setGuiasEmDuplicidade(guiasDuplicidades);

    this.setState({ openDrawerGuiasDuplicidade: true });
    this.props.hideLoading();
  }

  handleDrawerCloseGuiaDuplicidade = () => {
    this.setState({ openDrawerGuiasDuplicidade: false, });
    this.props.setGuiasEmDuplicidade([]);
  }
  handleCloseDialogJustificativa = () => {
    this.setState({ openDialogJustificativa: false });
  }
  _roundUp = (num, precision) => {
    precision = Math.pow(10, precision);
    return Math.round(Number(num) * precision) / precision;
  }

  _currency = (val) => {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', minimumFractionDigits: 2, maximumFractionDigits: 3 }).format(val);
  }
  selecionarValor = (valor) => {
    // this.handleClickOnElemento(this.props.idx, this.props.elemento);
    this.handleChangeValueUnitario(valor);
  }

  marcarElemento = async (elemento) => {
    this.setState({elementoEmEdicao: elemento});
    await this.props.selecionarElemento(elemento);
  }

  handleCloseDialogTrocarItem = () => {
    this.setState({ openDialogTrocarItem: false });
  }
  trocarItem = () => {
    this.setState({ openDialogTrocarItem: true, tituloFormDialog: 'Trocar Item do Recurso' });
  }

  handleSaveTrocarItem = async (item) => {
    this.setState({ openDialogTrocarItem: false, fetching: true });

    const newSelected = {
      ...this.state.elementoSelected
    };

    newSelected.desItem = item.desItem;
    newSelected.codItem = item.codItem;
    newSelected.codTabela = item.codTabela;
    newSelected.desTabela = item.desTabela;
    newSelected.dtaRealizacao = parse(this.state.elementoSelected.dtaRealizacao);
    newSelected.codItemTabela = item.codItemTabela;

    let result = await this.elementoApi.getValVigente(item.codItemTabela, newSelected.seqPrestador, newSelected.dtaRealizacao);

    let valor = Number(result.data.toString());

    newSelected.valUnitarioSolicitado = valor.toFixed(2).toString().replace('.', ',');
    newSelected.valTotalSolicitado = valor * newSelected.qtdSolicitada * newSelected.valPctReducaoAcrescimoSolicitado;

    this.props.elemento = newSelected;
    this.setState({ elementoSelected: newSelected, fetching: false });

  }  

  handleSaveTrocarItem_ = async (item) => {
    this.setState({ openDialogTrocarItem: false });

    const newSelected = {
      ...this.state.elementoSelected
    };

    this.props.showLoading('Salvando...');

    newSelected.dtaRealizacao = parse(this.state.elementoSelected.dtaRealizacao);
    newSelected.codItemTabela = item.codItemTabela;
    let result = await this.elementoApi.salvarAuditoriaElementoRecursoTrocaItem(this.props.loteSelecionado.codLoteGuia, newSelected);

    if (result === undefined || result.data === undefined) {
      this.props.showSnackbar('Não foi possível realizar a operação.', 'error', 4000, '', null, 'bottom');
      return;
    }
    if (result !== undefined && result.data.codigoRetorno === 1) {
      this.props.onOperacaoRealizada();
      this.props.showSnackbar(result.data.msgRetornoResumida, 'success', 4000, '', null, 'bottom');
    } else {
      const { mensagens } = result.data;
      this.props.showSnackbar(mensagens, 'error', 4000, '', null, 'bottom');
    }

    this.props.hideLoading();

  }  

  render() {
    const { classes, idx, readOnly, emAuditoria, elemento, isSelecionado } = this.props;
    const { elementoSelected } = this.state;

    const titleElemento =
      <div>
        <div className={classes.tituloElementoContainer}>
            {elemento.codItemTabela !== elemento.elementoOriginalDTO.codItemTabela &&
          <div className={classes.tituloElementoContainer}>
            <Typography
              component={'span'}
              className={classes.tituloElemento}
              title={`ITEM ORIGINAL - Tabela: ${elemento.elementoOriginalDTO.codTabela} - ${elemento.elementoOriginalDTO.desTabela}`}>
              {`ORIGINAL : ${elemento.elementoOriginalDTO.desTabela} • ${elemento.elementoOriginalDTO.codItem} ${elemento.elementoOriginalDTO.desTipoOutrasDesp || ''} ${elemento.elementoOriginalDTO.desItem}`}
            </Typography>
          </div>
        }
        <div className={classes.tituloElementoContainerRec}>
        {this.props.modoEdicaoGuia &&
          <FormControlLabel
            control={
              <Checkbox
                disabled={readOnly}
                checked={isSelecionado ? true : false}
                onChange={() => this.marcarElemento(elemento)}
                title='Marcar Item para Recorrer'
              />
            }
            className={classes.checkNegarEmLote}
          />
          }
            <IconButton
              title='Como o item foi totalmente glosado na guia recorrida, ou há permissão para a troca, é possível alterar seu código.'
              onClick={this.trocarItem}
              disabled={!isSelecionado || !this.props.modoEdicaoGuia}
              className={elemento.indPodeTrocarItem === 'N' || !this.props.modoEdicaoGuia ? classes.invisible : classes.buttonAcoes}
              >
            <Search />
            </IconButton>
          <Typography
            component={'span'}
            className={classes.tituloElemento}
            title={`Tabela: ${elemento.codTabela} - ${elemento.desTabela}`}>
            {`${elemento.desTabela} • ${elemento.codItem} ${elemento.desTipoOutrasDesp || ''} ${elemento.desItem}`}
            
            {elemento.dtaRealizacao !== null && (
              <Typography component={'p'} className={classes.secondaryHeading} title='Data da realização e hora'>
                {this.props.isGuiaSolicitacao ? 'solicitado em' : 'realizado em'} {format(elemento.dtaRealizacao, 'DD/MM/YYYY')}  {elemento.horInicio === null ? ' ' : ' ' + elemento.horInicio}
              </Typography>
            )}
          </Typography>
          </div>
        </div>
      </div>;

    const rowHead = <TableRow className={classes.tableRow}>
      <TableCell className={classes.tableHeadCellBranco} />
      {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableHeadCell} title='Quantidade'>Qtde.</TableCell>}
      {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableHeadCell} title='Valor unitário'>Val. unitário</TableCell>}
      {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableHeadCell} title='Percentual de redução e acréscimo.'>% Red./Acr.</TableCell>}
      {elementoSelected.indReapresentacao === 'S' && <TableCell className={classes.tableHeadCell} title='Valor que já foi Pago na guia original'>Pago</TableCell>}
      {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableHeadCell} title='Valor total'>Total</TableCell>}
      {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableHeadCellGlosado} title='Valor Recurso'>Valor Recurso</TableCell>}
      {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableHeadCellMais} title='Mais'>Mais</TableCell>}
    </TableRow>;

    const txtAjudaPercSolicitado =
      `${elementoSelected.valPctReducaoAcrescimoSolicitado === '1.0000' ||
        elementoSelected.valPctReducaoAcrescimoSolicitado === '0.0000' ||
        elementoSelected.valPctReducaoAcrescimoSolicitado === null
        ? 'Nenhum percentual de redução ou acrécimo solicitado.'
        : `O prestador está solicitando ${parseFloat((elementoSelected.valPctReducaoAcrescimoSolicitado - 1) * 100).toFixed(2)}% de ${elementoSelected.valPctReducaoAcrescimoSolicitado < 1 ? 'redução' : 'acréscimo'}.`}`;

    const rowSolicitado =
      <TableRow className={classes.tableRow}>
        <TableCell className={classes.tableRowCell}>Autorizado Original</TableCell>
        <TableCell className={classes.tableCell}>{elementoSelected.elementoOriginalDTO.qtdSolicitada}</TableCell>
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCell}>{this._currency(elementoSelected.elementoOriginalDTO.valUnitarioSolicitado)}</TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCell} title={txtAjudaPercSolicitado}>{elementoSelected.elementoOriginalDTO.valPctReducaoAcrescimoSolicitado}</TableCell>}
        {elementoSelected.indReapresentacao === 'S' && <TableCell className={classes.tableCell} title='Valor que já foi Pago na guia original'>{this._currency(elementoSelected.elementoOriginalDTO.valTotalAutorizado)}</TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCell}>{this._currency(elementoSelected.elementoOriginalDTO.valTotalSolicitado)}</TableCell>}
        <TableCell className={classes.tableCell}>-</TableCell>
        <TableCell className={classes.tableCellMais}>
          <Toolbar className={classes.tableCellMaisToolbar} disableGutters>
            <ButtonGlosas
              title={[elementoSelected.codItem, elementoSelected.desItem]}
              glosas={elementoSelected.glosas}
              emAuditoria={false} />
            <ButtonMotivoRecurso
              title={[elementoSelected.codItem, elementoSelected.desItem]}
              motivo={elementoSelected.txtMotivoRecurso}
            />
            <ButtonAlertas
              title={[elementoSelected.codItem, elementoSelected.desItem]}
              alertas={elementoSelected.alertas}
              handleViewDuplicidades={() => this.handleViewDuplicidades(elemento)}
            />
            <ButtonEquipe
              title={[elementoSelected.codItem, elementoSelected.desItem]}
              equipe={elementoSelected.equipe}
              valUnitarioVigente={elementoSelected.valUnitarioVigente}
              codPorteAnestesico={elementoSelected.codPorteAnestesico}
              dtaRealizacao={elementoSelected.dtaRealizacao}
              selecionarValor={this.selecionarValor} />
          </Toolbar>
        </TableCell>
      </TableRow >;

    const txtAjudaPercAutorizado =
      `${elementoSelected.valPctReducaoAcrescimoAutorizado === '1.0000' ||
        elementoSelected.valPctReducaoAcrescimoAutorizado === '0.0000' ||
        elementoSelected.valPctReducaoAcrescimoAutorizado === null
        ? 'Nenhum percentual de redução ou acrécimo autorizado.'
        : `Está sendo autorizado ${parseFloat((elementoSelected.valPctReducaoAcrescimoAutorizado - 1) * 100).toFixed(2)}% de ${elementoSelected.valPctReducaoAcrescimoAutorizado < 1 ? 'redução' : 'acréscimo'}.`}`;

    const rowAutorizado = emAuditoria
      ? <TableRow className={classes.tableRow}>
        <TableCell className={classes.tableRowCell}>Solicitado Recurso</TableCell>
        <TableCell className={classes.tableCell}>
          <NumberFormat
            disabled={!isSelecionado || !this.props.modoEdicaoGuia}
            allowNegative={false}
            allowEmptyFormatting={false}
            decimalScale={0}
            value={elementoSelected.qtdSolicitada}
            onValueChange={({ floatValue }) => {
              this.handleChangeValueQtde(floatValue);
            }}
            onClick={this.handleFocusOnInput}
            customInput={TextField}
            className={classes.textField}
            InputProps={{
              classes: {
                input: classes.inputResize
              }
            }}
            inputProps={{
              type: 'number',
              min: 0,
              step: 1
            }}
          />
        </TableCell>
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') &&
          <TableCell className={classes.tableCell}>
            <NumberFormat
              disabled={!isSelecionado || !this.props.modoEdicaoGuia}
              prefix={'R$ '}
              thousandSeparator={'.'}
              decimalSeparator={','}
              decimalScale={elementoSelected.codTipoItem === 1 ? 2 : 3} // procedimentos com duas casas, opme e despesas com 3
              allowNegative={false}
              allowEmptyFormatting={false}
              value={elementoSelected.valUnitarioSolicitado}
              onValueChange={({ floatValue }) => { this.handleChangeValueUnitario(floatValue); }}
              onClick={this.handleFocusOnInput}
              className={classes.textField}
              customInput={TextField}
              InputProps={{
                classes: {
                  input: classes.inputResize
                }
              }}
            />
          </TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') &&
          <TableCell className={classes.tableCell} title={txtAjudaPercAutorizado}>
            <NumberFormat
              disabled={!isSelecionado || !this.props.modoEdicaoGuia}
              allowNegative
              allowEmptyFormatting={false}
              decimalScale={4}
              value={
                (elementoSelected.valPctReducaoAcrescimoSolicitado !== null)
                  ? elementoSelected.valPctReducaoAcrescimoSolicitado : null}
              onValueChange={({ floatValue }) => { this.handleChangeValuePct(floatValue); }}
              onClick={this.handleFocusOnInput}
              customInput={TextField}
              className={classes.textField}
              InputProps={{
                classes: {
                  input: classes.inputResize
                }
              }}
              inputProps={{
                type: 'number',
                step: 0.0001
              }}
            />
          </TableCell>}
        {elementoSelected.indReapresentacao === 'S' && <TableCell className={classes.tableCell} title='Valor que já foi Pago na guia original'>{this._currency(elementoSelected.elementoOriginalDTO.valTotalAutorizado)}</TableCell>}
        <TableCell className={classes.tableCell}>
          {elementoSelected.valTotalAutorizado === null ? ''
            : elementoSelected.seqPrestador !== SEQ_PRESTADOR_CNU
              ? this._currency(this._roundUp(elementoSelected.valTotalAutorizado, 2))
              : this._currency(elementoSelected.valTotalAutorizado)}
        </TableCell>

        {isSelecionado
        ? <TableCell className={classes.tableCell} title='Valor Total Recurso'>
          {this._currency(this._roundUp((elementoSelected.valTotalSolicitado), 2))}
         </TableCell>
         : <TableCell className={classes.tableCell}>-</TableCell>}


        <TableCell className={classes.tableCellMais}>
          {!readOnly &&
            <Toolbar className={classes.tableCellMaisToolbar} disableGutters>
              <Button
                disabled={!isSelecionado || !this.props.modoEdicaoGuia}
                color='primary'
                className={classes.buttonOperation}
                title='Salvar Recurso...'
                onClick={() => this.salvarRecurso(elementoSelected)}>
                <SaveIcon />
              </Button>
              <Button
                disabled={!isSelecionado || elementoSelected.txtMotivoRecurso === null || !this.props.modoEdicaoGuia}
                color='primary'
                className={classes.buttonOperation}
                title='Apagar Recurso...'
                onClick={() => this.apagarRecurso(elementoSelected)}>
                <DeleteIcon />
              </Button>              
            </Toolbar>
          }
        </TableCell>
      </TableRow>
      : <TableRow className={classes.tableRow}>
        <TableCell className={classes.tableRowCell}>Solicitado Recurso</TableCell>
        <TableCell className={classes.tableCell}>{elemento.qtdAutorizada !== null ? elemento.qtdAutorizada : ''}</TableCell>
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCell}>{elemento.valUnitarioAutorizado !== null ? this._currency(elemento.valUnitarioAutorizado) : ''}</TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCell} title={txtAjudaPercAutorizado}>{elementoSelected.valPctReducaoAcrescimoAutorizado}</TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCell}>{elemento.valTotalAutorizado !== null ? this._currency(elemento.valTotalAutorizado) : ''}</TableCell>}
        {(!this.props.isGuiaSolicitacao || elementoSelected.tipoElementoGuia === 'OPME') && <TableCell className={classes.tableCellMais} />}
      </TableRow >;

    const txtAjudaPercVigente =
      `${elementoSelected.valTaxaVigente === '1.0000' ||
        elementoSelected.valTaxaVigente === '0.0000' ||
        elementoSelected.valTaxaVigente === null
        ? 'Nenhuma taxa vigente.'
        : `Taxa vigente é de ${parseFloat((elementoSelected.valTaxaVigente - 1) * 100).toFixed(2)}%.`}`;

    const adicionarMotivoGlosa = isSelecionado &&
      emAuditoria && !readOnly && this.props.modoEdicaoGuia &&
      <Typography
        component={'span'}
        className={classes.editableClick}
        onClick={() => this.addMotivoRecurso(elementoSelected)}>Informe o Motivo do Recurso
      </Typography>;

    return (
      <React.Fragment>
        {this.state.fetching ? <LinearProgressBlockScreen />
        :<Slide key={idx} direction='right' timeout={600} in mountOnEnter unmountOnExit>
          <Paper
            key={idx}
            className={`${classes.root} ${this.styleSituacaoElemento(this.getSituacao(elementoSelected))}`}
            onFocus={() => this.handleClickOnElemento(idx, elemento)}>
            {titleElemento}
            <Table>
              <TableHead>
                {rowHead}
              </TableHead>
              <TableBody className={classes.tableBody}>
                {rowSolicitado}
                {rowAutorizado}
              </TableBody>
            </Table>
            {adicionarMotivoGlosa}
          </Paper>
        </Slide>}
        {this.state.openDialogMotivoRecurso &&
          <AlertDialogSlideMotivoRecurso
            open={this.state.openDialogMotivoRecurso}
            handleClose={this.handleCloseDialogMotivoRecurso}
            handleClickIncluirMotivoRecurso={this.handleConfirmDialogMotivoRecurso}
            title={'Adicionar motivo do recurso do item'}
            motivoRecurso={elementoSelected.txtMotivoRecurso}
            message={''} />}

        {this.state.openDrawerGuiasDuplicidade &&
          <DrawerGuiasDuplicidade
            open={this.state.openDrawerGuiasDuplicidade}
            guias={this.props.guiasEmDuplicidade}
            handleClose={this.handleDrawerCloseGuiaDuplicidade}
          />}
        {this.state.openDialogTrocarItem &&
          <FormDialogTrocarItem
            open={this.state.openDialogTrocarItem}
            titulo={this.state.tituloFormDialog}            
            handleClose={this.handleCloseDialogTrocarItem}
            handleSave={this.handleSaveTrocarItem}
          />}
          
        <AlertDialog
          open={this.state.openDialogJustificativa}
          handleClose={this.handleCloseDialogJustificativa}
          title={this.state.dialogTitle}
          message={this.state.dialogMessage} />
        <AlertDialogSlide
          open={this.state.openDialogGlosaEmLote}
          handleClose={this.handleCloseDialogGlosaEmLote}
          handleClick={this.handleDialogConfirmGlosaEmLote}
          title={this.state.dialogTitleGlosaEmLote}
          message={this.state.dialogMessageGlosaEmLote} />
      </React.Fragment>
    );
  }
}
export default withAuditoria(withSnackbar(withLoading(withStyles(styles)(ElementoRecurso))));
